var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogoOptimized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.198 4.553H6.74a1.28 1.28 0 0 0-1.28 1.281v29.46c0 .708.572 1.28 1.28 1.28H36.2a1.28 1.28 0 0 0 1.28-1.28V5.833a1.28 1.28 0 0 0-1.28-1.28ZM14.956 31.84h-4.75V16.557h4.75v15.282Zm-2.373-17.371a2.755 2.755 0 1 1 2.753-2.754 2.759 2.759 0 0 1-2.753 2.754Zm20.16 17.37h-4.746v-7.432c0-1.773-.032-4.05-2.47-4.05-2.47 0-2.85 1.929-2.85 3.922v7.56h-4.743V16.558h4.555v2.09h.064c.633-1.201 2.182-2.47 4.495-2.47 4.811 0 5.696 3.166 5.696 7.28v8.382Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogoOptimized);
export default __webpack_public_path__ + "static/media/linkedinLogo-optimized.cfecd651c06546cee745baacbb84c532.svg";
export { ForwardRef as ReactComponent };